module.exports = __webpack_public_path__ + "bd0b7f550a2d07f22594e7f86f5f5f2d.svg";